import { env } from './env';

export const PANELS = ['queopinas', 'voceopina', 'quedices'] as const;

export type Panel = (typeof PANELS)[number];

export function getAppMap<T extends Record<Panel, unknown>>(config: T) {
  return config;
}

export function toCurrentApp<T extends Record<Panel, unknown>>(config: T) {
  return config[env.appId] as T[Panel];
}

export const appConfig = getAppMap({
  queopinas: {
    defaultLanguage: 'es',
    defaultCountry: '',
    defaultCurrency: 'USD',
    defaultLocale: '',
    minimumRedemption: 2000,
    instagramUrl: 'https://www.instagram.com/queopinascom',
    requestDataUrl: null,
    name: 'QueOpinas',
  },

  voceopina: {
    defaultLanguage: 'pt',
    defaultCountry: 'BR',
    defaultCurrency: 'BRL',
    defaultLocale: 'pt',
    minimumRedemption: 2000,
    instagramUrl: 'https://instagram.com/voceopinabr',
    requestDataUrl: null,
    name: 'VocêOpina',
  },

  quedices: {
    defaultLanguage: 'es',
    defaultCountry: 'ES',
    defaultCurrency: 'EUR',
    defaultLocale: 'es',
    minimumRedemption: 2000,
    instagramUrl: 'https://www.instagram.com/que.dices.es/',
    requestDataUrl: 'https://soporte2.quedices.es/es/support/tickets/new',
    name: 'QueDices',
  },
})[env.appId];
